import {axios as http} from "@/plugins/http"

export default class Api {
    static addImage(wishId, image) {
        return http.post("/api/v1/wishlist/wish-image", createFormData({
            wish_id: wishId,
            image: image,
        })).then((resp) => {
            return resp.data["item"]
        })
    }
}

const createFormData = (data) => {
    const formData = new FormData()
    Object.entries(data).forEach(([key, val]) => formData.append(key, val))
    return formData
}
